export const Logo = ({ light = false }) => (
    <span className="flex items-center gap-2 sm:gap-3" data-testid="brand-logo">
        <img
            src="/logo-refrigelar.png"
            alt="Refrigelar — assistência técnica em geladeiras e lava e seca"
            className="h-10 w-10 sm:h-12 sm:w-12 rounded-full select-none shadow-[0_4px_14px_-4px_rgba(48,52,58,0.5)]"
            width="48"
            height="48"
        />
        <span
            className={`font-display font-extrabold text-lg sm:text-2xl tracking-tight leading-none ${
                light ? "text-white" : "text-graphite"
            }`}
        >
            REFRIGE<span className="text-brand">LAR</span>
        </span>
    </span>
);
